var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadCurrent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22.32,
    viewBox: "0 0 25 31",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_184_1365)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.58449 20.7686V26.1276C7.58449 28.5322 5.63492 30.4817 3.23039 30.4817H0.0785522V24.3169C1.85272 20.5164 5.94554 20.7686 7.58632 20.7686H7.58449Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6241 18.7624C18.6497 18.7861 24.619 30.447 24.6464 30.4817H19.0882C15.0137 30.9184 13.2158 23.2352 11.533 20.7686C13.9357 20.7686 15.7829 20.2003 17.0034 19.6595",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2171 9.53161C24.2171 13.1055 22.5471 15.7933 19.7826 17.4541C19.6931 17.5071 19.6035 17.5601 19.5176 17.6113C19.5176 17.6113 19.514 17.6131 19.5122 17.6149C19.3404 17.7118 19.1394 17.5382 19.2107 17.3536C19.3075 17.1033 19.4062 16.8128 19.4939 16.4857C19.6145 16.0363 20.8277 11.2035 17.6503 8.10278C15.3956 5.90289 12.3717 5.97963 11.7066 6.01069H4.75974C2.35521 6.01252 0.40564 4.06295 0.40564 1.65841V0.5H13.3072C20.0329 0.5 24.2153 3.74502 24.2153 9.53161H24.2171Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9949 9.0803C16.068 9.42929 16.1082 9.81847 16.1082 10.2533C16.1082 13.4984 13.8407 14.2018 11.2991 14.2018H4.3541C1.94957 14.2018 0 16.1514 0 18.5559V23.692C1.77416 19.8916 5.86698 20.1437 7.50594 20.1437H11.4544C12.865 20.1437 14.0873 19.9464 15.1014 19.6741C17.875 18.9305 19.6766 16.2153 19.218 13.3796C19.2088 13.3211 19.1979 13.2608 19.1869 13.2005C18.5766 9.87146 15.9931 9.07665 15.9931 9.07665L15.9949 9.0803Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_184_1365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.6464,
    height: 30,
    fill: "currentColor",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadCurrent);
export default __webpack_public_path__ + "static/media/rad-current.422d891fc6c2b23b077f49e2129350ac.svg";
export { ForwardRef as ReactComponent };